import { useEffect, useRef, useState } from 'react';
import { Tree, Dropdown, Input, Menu, Modal, Spin } from 'antd';
import { driver } from 'driver.js';
import SvgIcon from '&/components/SvgIcon';
import { getTargetElement } from '&/utils/common';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { createUUID } from '&/utils/common';
import '&/components/ConstructionDrawing/Directory.scss';
import quickStartGuide from '&/store/quickStartGuide';
import { useEventEmitter } from '&/utils/customHooks/useEventEmitter';
import {
    getOrganizationList,
    addDep,
    deleteDep,
    deleteEnt,
    addEnt,
    rename,
} from '@/api/personCenter/organization';
import { useStoreState } from '&/utils/customHooks';
import 'driver.js/dist/driver.css';
import './index.scss';

let timer = null;
let driverObj = null;
export default function OrganizationTree() {
    const formatTreeData = obj => {
        for (var i in obj) {
            obj[i].isEditable = false;
            obj[i].value = obj[i].name || obj[i].title;
            obj[i].defaultValue = obj[i].name || obj[i].title;
            obj[i].title = obj[i].value;
            obj[i].key = obj[i].tag;
            if (obj[i].hasOwnProperty('department')) {
                obj[i].children = obj[i].department;
                obj[i].isLeaf = false;
            } else {
                obj[i].isLeaf = true;
            }
            if (obj[i].children) {
                if (obj[i].children.length === 0) {
                    obj[i].isLeaf = true;
                }
                formatTreeData(obj[i].children);
            }
        }
    };
    const { organization = {} } = useStoreState('appStore');
    const wrap = useRef();
    const selectFlag = useRef(true);
    const currentNode = useRef();
    const newNodeKey = useRef();
    const handler = useRef();
    const orgTreeRef = useRef();
    const [selectedKeys, setSelectedKeys] = useState([]);
    const { emit, useListener } = useEventEmitter();

    const [treeData, setTreeData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [expandedKeys, setExpandedKeys] = useState([]);
    // const [selectNode, setSelectNode] = useState([]);
    const [newNode, setNewNode] = useState(null);

    const entId = new URLSearchParams(window.location.search).get('entId');

    const depId = new URLSearchParams(window.location.search).get('depId');

    useListener('update-tree-data', () => {
        getTreeNode(true);
    });

    useEffect(() => {
        if (newNode) {
            onEdit(newNode.key, newNode.name);
        }
    }, [newNode]);

    useEffect(() => {
        emit('organization', [...treeData]);
        if (treeData.length > 0) {
            timer = setTimeout(() => {
                quickStartGuide.queryGuidance('entOrg').then(entOrg => {
                    if (+entOrg !== 0) return;
                    const driveFn = () => {
                        if (!orgTreeRef.current) {
                            timer = setTimeout(driveFn);
                        } else {
                            const [dropdownEle] =
                                orgTreeRef.current.querySelectorAll(
                                    '.directory-dropdown'
                                );
                            if (dropdownEle) {
                                dropdownEle.click();
                            } else {
                                clearTimeout(timer);
                                timer = null;
                                return;
                            }
                            driverObj = driver({
                                disableActiveInteraction: true,
                                allowClose: false,
                            });
                            const skipFn = () => {
                                quickStartGuide.setGuidanceStatus('entOrg', 2);
                                driverObj.destroy();
                            };

                            timer = setTimeout(() => {
                                const targetEle = document.querySelector(
                                    '.directory-dropdown-overlay'
                                );
                                const addMemberlist = document.querySelector(
                                    '.organization-member-list'
                                );
                                const targetBtnEle =
                                    addMemberlist.querySelector('button');
                                driverObj.setSteps([
                                    {
                                        element: targetEle,
                                        popover: {
                                            title: intl.get(
                                                'quickStartGuidance.org.title1'
                                            ),
                                            description: intl.get(
                                                'quickStartGuidance.org.description1'
                                            ),
                                            side: 'bottom',
                                            align: 'center',
                                            nextBtnText: intl.get(
                                                'quickStartGuidance.button.next'
                                            ),
                                            showButtons: ['next'],
                                            onPopoverRender: dom => {
                                                const {
                                                    previousButton,
                                                    footer,
                                                } = dom;
                                                previousButton.style.display =
                                                    'none';
                                                const btnsWrap =
                                                    footer.querySelector(
                                                        '.driver-popover-navigation-btns'
                                                    );
                                                const spanEle =
                                                    document.createElement(
                                                        'span'
                                                    );
                                                spanEle.classList.add(
                                                    'skip-btn'
                                                );
                                                spanEle.innerText = intl.get(
                                                    'quickStartGuidance.button.skip',
                                                    { current: 1, total: 2 }
                                                );
                                                spanEle.onclick = skipFn;
                                                btnsWrap.insertBefore(
                                                    spanEle,
                                                    btnsWrap.children[0]
                                                );
                                            },
                                            onNextClick: () => {
                                                dropdownEle &&
                                                    dropdownEle.click();
                                                const [firstNode] = treeData;
                                                const [targetNode] =
                                                    firstNode.children;
                                                setSelectedKeys([
                                                    targetNode.key,
                                                ]);
                                                emit(
                                                    'selected-node',
                                                    { ...targetNode },
                                                    [...treeData]
                                                );
                                                driverObj.moveNext();
                                            },
                                        },
                                    },
                                    {
                                        element: targetBtnEle,
                                        popover: {
                                            title: intl.get(
                                                'quickStartGuidance.org.title2'
                                            ),
                                            description: intl.get(
                                                'quickStartGuidance.org.description2'
                                            ),
                                            side: 'bottom',
                                            align: 'end',
                                            doneBtnText: intl.get(
                                                'quickStartGuidance.button.done'
                                            ),
                                            prevBtnText: intl.get(
                                                'quickStartGuidance.button.previous'
                                            ),
                                            onPopoverRender: dom => {
                                                const { footer } = dom;
                                                const btnsWrap =
                                                    footer.querySelector(
                                                        '.driver-popover-navigation-btns'
                                                    );
                                                const spanEle =
                                                    document.createElement(
                                                        'span'
                                                    );
                                                spanEle.classList.add(
                                                    'skip-btn'
                                                );
                                                spanEle.innerText = intl.get(
                                                    'quickStartGuidance.button.skip',
                                                    { current: 2, total: 2 }
                                                );
                                                spanEle.onclick = skipFn;
                                                btnsWrap.insertBefore(
                                                    spanEle,
                                                    btnsWrap.children[0]
                                                );
                                            },
                                            onPrevClick: () => {
                                                dropdownEle &&
                                                    dropdownEle.click();
                                                driverObj.movePrevious();
                                            },
                                            onNextClick: () => {
                                                skipFn();
                                            },
                                        },
                                    },
                                ]);
                                driverObj.drive();
                            }, 50);
                        }
                    };
                    driveFn();
                });
            });
        }
        return () => {
            timer && clearTimeout(timer);
            driverObj && driverObj.destroy();
        };
    }, [treeData]);

    const getDepById = (data, id) => {
        let result = null;

        function getTreeItem(data, id) {
            data.map(item => {
                if (item.id === id && !item.children) {
                    // 只找叶子节点
                    result = item; // 结果赋值
                } else {
                    if (item.children) {
                        getTreeItem(item.children, id);
                    }
                }
                return item;
            });
        }
        getTreeItem(data, id);

        return result;
    };

    const getEntById = (data, id) => {
        return data.filter(v => v.id === id)[0];
    };

    const getTreeNode = (isTriggerMemberListUpdate = false) => {
        return getOrganizationList().then(res => {
            if (!res || !res.data) return;
            let data = res.data.map(item => {
                item.department = item.department.map(sItem => {
                    return { ...sItem, entVip: item.entVip };
                });
                return { ...item };
            });
            formatTreeData(data);
            setTreeData(data);
            if (isTriggerMemberListUpdate) {
                let defaultItem = data[0];
                if (depId) {
                    let expandNode = getEntById(data, entId);
                    setExpandedKeys(prev => [
                        ...new Set([...prev, expandNode.key]),
                    ]);
                    defaultItem = getDepById(data, depId);
                }
                setSelectedKeys([defaultItem.key]);
                emit('selected-node', { ...defaultItem }, [...data]);
            }
            return data;
        });
    };

    useEffect(() => {
        getTreeNode(true).then(res => {
            setExpandedKeys(Array.from(new Set(res.map(item => item.key))));
        });
    }, []);

    const onSelect = (keys, { node }) => {
        if (node.key !== selectedKeys[0]) {
            setSelectedKeys([node.key]);
            emit('selected-node', { ...node }, [...treeData]);
        }
    };

    const onExpand = expandedKeys => {
        setExpandedKeys(expandedKeys);
    };

    const onAdd = (nodeData, isLeaf) => {
        let hierarchy = [...treeData];
        if (newNodeKey.current) {
            //新增node 之前如果已经有别的新增节点，则需要先删除掉
            deleteNode(newNodeKey.current, hierarchy);
        }
        newNodeKey.current = createUUID();
        let node = {
            value: '',
            defaultValue: '',
            key: newNodeKey.current, // 这个 key 应该是唯一的。 Tip: The key should be unique
            parentKey: 0,
            isEditable: false,
            isLeaf: true,
            is_new: 1,
            enterpriseId: nodeData?.id,
        };

        if (!isLeaf) {
            node.children = [];
            hierarchy.push(node);
        } else {
            hierarchy.forEach(ele => {
                if (nodeData.key === ele.key) {
                    setExpandedKeys(prev => [
                        ...new Set([...prev, nodeData.key]),
                    ]);
                    ele.children.push(node);
                }
            });
        }
        setTreeData(hierarchy);
        setNewNode(node);
    };

    const changeNode = (key, value, data) =>
        data.forEach(item => {
            if (item.key === key) {
                item.value = value;
            }
            if (item.children) {
                changeNode(key, value, item.children);
            }
        });

    const onChange = (e, key) => {
        e.stopPropagation();
        changeNode(key, e.target.value, treeData);
        setTreeData([...treeData]);
    };

    const removeOutClick = () => {
        handler.current &&
            document.removeEventListener('click', handler.current);
        handler.current = null;
    };

    const closeNode = (key, defaultValue, data) =>
        data.forEach(item => {
            item.isEditable = false;
            if (item.key === key) {
                item.value = defaultValue;
            }
            if (item.children) {
                closeNode(key, defaultValue, item.children);
            }
        });

    const onClose = (key, defaultValue, isNew) => {
        removeOutClick();
        selectFlag.current = true;
        newNodeKey.current = undefined;
        if (isNew === 1) {
            setTreeData(prev => {
                const NEXT = [...prev];
                deleteNode(key, NEXT);
                return NEXT;
            });
        } else {
            setTreeData(prev => {
                const NEXT = [...prev];
                closeNode(key, defaultValue, NEXT);
                return NEXT;
            });
        }
    };

    // const saveNode = (key, data) =>
    //     data.forEach(item => {
    //         if (item.key === key) {
    //             item.defaultValue = item.value;
    //         }
    //         if (item.children) {
    //             saveNode(key, item.children);
    //         }
    //         item.isEditable = false;
    //     });

    const onSave = (key, defaultValue, isNew, _nodeData) => {
        removeOutClick();
        selectFlag.current = true;
        setLoading(true);
        let apiPromise,
            isRename = false;
        if (isNew) {
            if (!_nodeData.children) {
                apiPromise = addDep({
                    depName: _nodeData.value,
                    entId: _nodeData.enterpriseId,
                });
            } else {
                apiPromise = addEnt({ entName: _nodeData.value });
            }
        } else {
            let params;
            isRename = true;
            if (!_nodeData.children) {
                params = {
                    rename: _nodeData.value,
                    entId: _nodeData.enterpriseId,
                    depId: _nodeData.id,
                };
            } else {
                params = { rename: _nodeData.value, entId: _nodeData.id };
            }
            apiPromise = rename(params);
        }

        apiPromise
            .then(() => {
                getTreeNode();
                if (isRename && selectedKeys[0] === _nodeData.key) {
                    emit('selected-node', { ..._nodeData }, [...treeData]);
                }
            })
            .catch(() => {
                onClose(key, defaultValue, isNew);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const clickOutside = (target, key, defaultValue) => {
        if (target) {
            handler.current = event => {
                const targets = Array.isArray(target) ? target : [target];
                if (
                    targets.some(targetItem => {
                        const targetElement = getTargetElement(targetItem);
                        return (
                            !targetElement ||
                            targetElement?.contains(event.target)
                        );
                    })
                ) {
                    return;
                }
                onClose(key, defaultValue, currentNode.current.is_new);
            };

            document.addEventListener('click', handler.current);
        }
    };

    const editNode = (key, data) => {
        data.forEach(item => {
            //   return
            item.isEditable = item.key === key;
            //Tip: Must have, when a node is editable, and you click a button to make other node editable, the node which you don't save yet will be not editable, and its value should be defaultValue
            item.value = item.defaultValue; // 当某节点处于编辑状态，并改变数据，点击编辑其他节点时，此节点变成不可编辑状态，value 需要回退到 defaultvalue
            if (item.children) {
                item.children = editNode(key, item.children);
            }
        });
        return data;
    };

    const onEdit = (key, defaultValue, e) => {
        selectFlag.current = true;
        if (e) {
            e.domEvent.stopPropagation();
        }
        setTreeData(prev => {
            let NEXT = [...prev];
            if (newNodeKey.current && e) {
                //新增的时候，直接去编辑别的节点了，那么先删除新增的节点
                deleteNode(newNodeKey.current, NEXT);
            }
            NEXT = editNode(key, NEXT);
            return NEXT;
        });
        // removeOutClick();

        setTimeout(() => {
            clickOutside(wrap.current, key, defaultValue);
        }, 300);
    };

    const deleteNode = (key, data) =>
        data.forEach((item, index) => {
            if (item.key === key) {
                data.splice(index, 1);
                return;
            } else {
                if (item.children) {
                    deleteNode(key, item.children);
                }
            }
        });

    const onDelete = (key, e, nodeData) => {
        if (e) {
            e.domEvent.stopPropagation();
        }

        Modal.confirm({
            title: intl.get('base.warning'),
            icon: <ExclamationCircleOutlined />,
            content: '确定要删除吗',
            centered: true,
            okText: intl.get('base.confirm'),
            cancelText: intl.get('base.cancel'),
            wrapClassName: 'delete-tree-node-modal',
            className: 'delete-tree-node-modal',
            async onOk(close) {
                try {
                    if (!nodeData.children) {
                        await deleteDep({
                            depId: nodeData.id,
                            entId: nodeData.enterpriseId,
                        });
                    } else {
                        await deleteEnt({ entId: nodeData.id });
                    }

                    deleteNode(key, treeData);
                    setTreeData([...treeData]);
                    close();
                } catch (e) {
                    close();
                }
            },
        });
    };

    const titleMenu = nodeData => (
        <Menu>
            {nodeData.children && (
                <Menu.Item
                    key="0"
                    onClick={() => {
                        onAdd(nodeData, true);
                    }}>
                    添加部门
                </Menu.Item>
            )}
            {+nodeData.pid !== 0 ? (
                <Menu.Item
                    key="1"
                    onClick={e =>
                        onEdit(nodeData.key, nodeData.defaultValue, e)
                    }>
                    重命名
                </Menu.Item>
            ) : null}
            {+nodeData.pid !== 0 ? (
                <Menu.Item
                    key="2"
                    onClick={e => onDelete(nodeData.key, e, nodeData)}>
                    删除
                </Menu.Item>
            ) : null}
        </Menu>
    );

    const handleMore = e => {
        removeOutClick();
        e.stopPropagation();
    };

    const titleRender = nodeData => {
        if (nodeData.isEditable) {
            return (
                <span
                    onClick={e => e.stopPropagation()}
                    ref={function (span) {
                        if (span !== null) {
                            wrap.current = span;
                        }
                    }}
                    className="edit-wrap"
                    style={{ overflow: 'hidden' }}>
                    <Input
                        ref={function (input) {
                            if (input != null) {
                                if (selectFlag.current) {
                                    selectFlag.current = false;
                                    input.select();
                                }
                                input.focus();
                                currentNode.current = nodeData;
                            }
                        }}
                        maxLength={25}
                        size="mini"
                        className="edit-input"
                        value={nodeData.value}
                        onChange={e => onChange(e, nodeData.key)}
                        onPressEnter={() =>
                            onSave(
                                nodeData.key,
                                nodeData.defaultValue,
                                nodeData.is_new,
                                nodeData
                            )
                        }
                    />
                    <SvgIcon
                        iconName="icon-confirm"
                        onClick={() =>
                            !!nodeData.value.trim() &&
                            onSave(
                                nodeData.key,
                                nodeData.defaultValue,
                                nodeData.is_new,
                                nodeData
                            )
                        }
                        className={`edit-icon ${
                            nodeData.value === '' ? 'disabled-hdc-dom' : ''
                        }`}
                    />
                    <SvgIcon
                        className="edit-icon"
                        iconName="icon-del"
                        onClick={() =>
                            onClose(
                                nodeData.key,
                                nodeData.defaultValue,
                                nodeData.is_new
                            )
                        }
                    />
                    {/* <Icon type='close' style={{ marginLeft: 10 }} onClick={() => onClose(item.key, item.defaultValue)} />
                    <Icon type='check' style={{ marginLeft: 10 }} onClick={() => onSave(item.key)} /> */}
                </span>
            );
        } else {
            return (
                <>
                    <div className="left">
                        <div className="text-wrap">
                            <div className="hide-text">{nodeData.value}</div>
                            <div className={`text-no-wrap title`}>
                                {nodeData.value}
                            </div>
                        </div>
                    </div>

                    {organization.roleFlag === 'admin' && (
                        <Dropdown
                            overlay={titleMenu(nodeData)}
                            trigger={['click']}
                            // getPopupContainer={() =>
                            //     document.querySelector('.pdf-root')
                            // }
                            overlayClassName="directory-dropdown-overlay"
                            className="directory-dropdown">
                            <i
                                className="icon-more-h filled more"
                                onClick={event => handleMore(event)}></i>
                        </Dropdown>
                    )}
                    {/* {!nodeData.isLeaf && <i className="icon-plus outlined" style={{}} onClick={ }></i>} */}
                </>
            );
        }
    };
    return (
        <Spin spinning={loading}>
            <div className=" organization-tree" ref={orgTreeRef}>
                <div className="header">
                    {intl.get('organizationTree.organization')}
                </div>
                <Tree
                    onSelect={onSelect}
                    onExpand={onExpand}
                    autoExpandParent
                    titleRender={titleRender}
                    selectedKeys={selectedKeys}
                    expandedKeys={expandedKeys}
                    treeData={treeData}
                />
                {organization.roleFlag === 'admin' && (
                    <div
                        className="add-company-btn"
                        onClick={() => {
                            removeOutClick();
                            onAdd(null, false);
                        }}>
                        <i className="icon-plus outlined" />
                        <span>添加子公司</span>
                    </div>
                )}
            </div>
        </Spin>
    );
}
